/* eslint-disable react-hooks/exhaustive-deps */
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import Table from "../../../components/table/Table";
import { formatDate, loggedInUser } from "../../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import {
  getCompanyClients,
  getHmoData,
  setPagination,
} from "../../../features/hmo/hmoSlice";
import TablePreloader from "../../../components/Loader/TablePreloader";
import { IError } from "../../../utils/icons.utils";

const CompanyClient = () => {
  let user = {};
  if (loggedInUser) {
    user = JSON.parse(loggedInUser);
  }
  const hmoId = user?.hmos[0]?.id,
    dispatch = useDispatch(),
    { pagination, companyClients } = useSelector(getHmoData),
    [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cb = () => {};
    if (pagination.search) {
      dispatch(setPagination({ page: 1 }));
      cb = setTimeout(
        (_) => (async () => await dispatch(getCompanyClients(hmoId)))(),
        700
      );
    } else cb = dispatch(getCompanyClients(hmoId));

    return () => {
      clearTimeout(cb);
    };
  }, [pagination.search, pagination.page]);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const data = companyClients?.map((companyClient) => ({
    Name: companyClient?.Company?.name || "N/A",
    "Email Address": companyClient?.Company?.email || "N/A",
    "Phone number": companyClient?.Company?.phoneNumber || "N/A",
    "Registered Date": formatDate(companyClient?.Company?.createdAt) || "N/A",
    "Subscription Status": companyClient?.active ? "Active" : "Inactive",
    _data: companyClient,
  }));

  return (
    <Box
      className="pt-8 px-8 mt-8 pb-2 bg-[var(--c-bg-color)] rounded-lg w-full"
      sx={{ p: 0 }}
    >
      <Box className="flex justify-between mb-2">
        <Typography>Company Clients</Typography>
      </Box>
      {isLoading ? (
        <TablePreloader />
      ) : data?.length ? (
        <Table
          {...{
            // dropdownMenu,
            data,
            pagination,
            setPagination,
          }}
        />
      ) : (
        <Box
          className="pt-8 pb-28 mt-8 bg-[var(--c-bg-color)] w-100% rounded-lg flex flex-col justify-center"
          sx={{ p: 0 }}
        >
          <img
            className="m-auto w-[350px] mt-8"
            src={IError}
            alt={"error"}
            loading="lazy"
          />
          <Typography className="flex justify-center text-[400] text-xl text-[#040316] mx-2 text-center">
            No Users in the system at the moment
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default CompanyClient;
